import { PropsWithChildren, useState, FC } from 'react';
import { DialogTrigger, Dialog } from '@ui/components';

import { EmployeesMassImportFileUpload } from './employees-mass-import-file-upload/employees-mass-import-file-upload';
import { EmployeesMassImportSummary } from './employees-mass-import-summary/employees-mass-import-summary';
import { EmployeesMassImportRemove } from './employees-mass-import-remove/employees-mass-import-remove';
import { useEmployeesMassImport } from './use-employees-mass-import';

export const EmployeesMassImportDialog: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const { resetFile, dialogType, uploadFile, downloadErrorFileCsv, saveImport } =
    useEmployeesMassImport(() => {
      setOpen(false);
      resetFile();
    });

  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) {
          resetFile();
        }
        setOpen(value);
      }}
      open={open}
    >
      <DialogTrigger asChild>{children}</DialogTrigger>
      {dialogType === 'UPLOAD' && <EmployeesMassImportFileUpload uploadFile={uploadFile} />}
      {dialogType === 'SUMMARY' && (
        <EmployeesMassImportSummary
          downloadErrorFileCsv={downloadErrorFileCsv}
          saveImport={saveImport}
        />
      )}
      {dialogType === 'REMOVE' && <EmployeesMassImportRemove />}
    </Dialog>
  );
};
